import React from "react";
import {Dropdown, OverlayTrigger, Tooltip} from "react-bootstrap";
import {CustomMenuStyled, DropDownButton} from "./sharedDDL";

const RejectionDDL = ({
  id,
  list,
  textSelector,
  valueSelector,
  toolTipSelector,
  tooltipActive = true,
  onChange,
  disabled,
  selectedKey,
  getKeyFromListItem = valueSelector,
  isValueSelectorUniqueForId = true
}) => {
  if (!list) {
    list = [];
  }
  let value = list.find((x, idx) => getKeyFromListItem(x, idx) === selectedKey);

  const Wrapper = ({ children, item, itemKey }) => {
    if (tooltipActive) {
      return (
        <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip id={`${id}-option-tooltip-${itemKey}`}>
              {toolTipSelector ? toolTipSelector(item) : textSelector(item)}
            </Tooltip>
          }
        >
          {children}
        </OverlayTrigger>
      );
    }
    return <>{children}</>;
  };

  return (
    <Dropdown>
      <Dropdown.Toggle
        id={id}
        as={DropDownButton}
        disabled={disabled}
        className="w-100"
      >
        <span>{value == null ? "-Select-" : textSelector(value)}</span>
        <i className="fa fa-chevron-down" />
      </Dropdown.Toggle>
      <Dropdown.Menu as={CustomMenuStyled} cusHeight={""}>
        <Dropdown.Item
          id={`${id}-option-select`}
          style={{}}
          onClick={() => onChange(null)}
          active={value == null}
        >
          {"-Select-"}
        </Dropdown.Item>
        {list.map((item, idx) => {
          const itemKey = valueSelector
            ? isValueSelectorUniqueForId
              ? valueSelector(item, idx)
              : idx
            : idx;

          return (
            <Wrapper
              key={`${id}-option-wrapper-${itemKey}-${idx}`}
              item={item}
              itemKey={`${itemKey}-${idx}`}
            >
              <Dropdown.Item
                id={`${id}-option-${itemKey}`}
                style={{}}
                onClick={() => onChange(valueSelector(item, idx), idx)}
                active={value == null ? false : getKeyFromListItem(value, idx) === getKeyFromListItem(item, idx)}
              >
                {textSelector(item)}
              </Dropdown.Item>
            </Wrapper>
          );
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export { RejectionDDL };
